/* RESPONSIBLE TEAM: team-ai-agent */
import FinAIAgentTasksIndexRoute from 'embercom/routes/apps/app/automation/fin-ai-agent/tasks/index';

export default class FinAiAgentEcommerceTasksIndexRoute extends FinAIAgentTasksIndexRoute {
  analytics = {
    section: 'automation',
    place: 'fin-ai-agent.ecommerce.tasks',
  };
}
